import script from "./kalio-radio-inputs.vue?vue&type=script&setup=true&lang=ts"
export * from "./kalio-radio-inputs.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__